module.exports = "<div class=\"m-grid__item m-grid__item--fluid\">\n\t<router-outlet></router-outlet>\n</div>\n<!--\n</div>\n-->\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/theme/pages/default/aside-left-display-disabled/aside-left-display-disabled.component.html
// module id = ./src/app/theme/pages/default/aside-left-display-disabled/aside-left-display-disabled.component.html
// module chunks = main